export const Types = {
    GET_ITEMGROUPLIST: "GET_ITEMGROUPLIST",
    SET_ITEMGROUPLIST: "SET_ITEMGROUPLIST",
    GET_ITEMSBYGROUP: "GET_ITEMSBYGROUP",
    SET_ITEMSBYGROUP: "SET_ITEMSBYGROUP",
    CIG_UPDATE: "CIG_UPDATE",
    CIG_CREATE: "CIG_CREATE",
    CIG_DELETE: "CIG_DELETE",
    DELETE_CIG_SUCCESS: "DELETE_CIG_SUCCESS",
    //for check items
    GET_ITEMLIST: "GET_ITEMLIST",
    SET_ITEMLIST: "SET_ITEMLIST",
    CI_UPDATE: "CI_UPDATE",
    CI_CREATE: "CI_CREATE",
    CI_DELETE: "CI_DELETE",
    DELETE_CI_SUCCESS: "DELETE_CI_SUCCESS",
    // planned maintenance
    GET_PLANNED_ITEMGROUPLIST: "GET_PLANNED_ITEMGROUPLIST",
    SET_PLANNED_ITEMGROUPLIST: "SET_PLANNED_ITEMGROUPLIST",
    GET_PLANNED_ITEMSBYGROUP: "GET_PLANNED_ITEMSBYGROUP",
    SET_PLANNED_ITEMSBYGROUP: "SET_PLANNED_ITEMSBYGROUP",
    PLANNED_CIG_UPDATE: "PLANNED_CIG_UPDATE",
    PLANNED_CIG_CREATE: "PLANNED_CIG_CREATE",
    PLANNED_CIG_DELETE: "PLANNED_CIG_DELETE",
    DELETE_PLANNED_CIG_SUCCESS: "DELETE_PLANNED_CIG_SUCCESS",
    //for check items
    GET_PLANNED_ITEMLIST: "GET_PLANNED_ITEMLIST",
    SET_PLANNED_ITEMLIST: "SET_PLANNED_ITEMLIST",
    PLANNED_CI_UPDATE: "PLANNED_CI_UPDATE",
    PLANNED_CI_CREATE: "PLANNED_CI_CREATE",
    PLANNED_CI_DELETE: "PLANNED_CI_DELETE",
    DELETE_PLANNED_CI_SUCCESS: "DELETE_PLANNED_CI_SUCCESS",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",

    GET_PLANNED_CHECK_ITEM_FILES: "GET_PLANNED_CHECK_ITEM_FILES",
    SET_PLANNED_CHECK_ITEM_FILES: "SET_PLANNED_CHECK_ITEM_FILES",
    POST_PLANNED_CHECK_ITEM_FILES: "POST_PLANNED_CHECK_ITEM_FILES",
    DELETE_PLANNED_CHECK_ITEM_FILES: "DELETE_PLANNED_CHECK_ITEM_FILES",
    GET_AUTONOMOUS_CHECK_ITEM_FILES: "GET_AUTONOMOUS_CHECK_ITEM_FILES",
    SET_AUTONOMOUS_CHECK_ITEM_FILES: "SET_AUTONOMOUS_CHECK_ITEM_FILES",
    POST_AUTONOMOUS_CHECK_ITEM_FILES: "POST_AUTONOMOUS_CHECK_ITEM_FILES",
    DELETE_AUTONOMOUS_CHECK_ITEM_FILES: "DELETE_AUTONOMOUS_CHECK_ITEM_FILES",
};

export const getList = (payload) => ({
    type: Types.GET_ITEMGROUPLIST,
    payload: payload,
});

export const setList = (payload) => ({
    type: Types.SET_ITEMGROUPLIST,
    payload: payload,
});

export const getCheckItemsByGroup = (payload) => ({
    type: Types.GET_ITEMSBYGROUP,
    payload: payload,
});

export const setCheckItemsByGroup = (payload) => ({
    type: Types.SET_ITEMSBYGROUP,
    payload: payload,
});

export const updateCIG = (payload) => ({
    type: Types.CIG_UPDATE,
    payload: payload,
});

export const addCIG = (payload) => ({
    type: Types.CIG_CREATE,
    payload: payload,
});

export const deleteCIG = (payload) => ({
    type: Types.CIG_DELETE,
    payload: payload,
});

export const deleteCIGSuccess = (payload) => ({
    type: Types.DELETE_CIG_SUCCESS,
    payload,
});

// for check items

export const getListOfItems = () => ({
    type: Types.GET_ITEMLIST,
});

export const setListOfItems = (payload) => ({
    type: Types.SET_ITEMLIST,
    payload: payload,
});

export const updateCI = (payload) => ({
    type: Types.CI_UPDATE,
    payload: payload,
});

export const addCI = (payload) => ({
    type: Types.CI_CREATE,
    payload: payload,
});

export const deleteCI = (payload) => ({
    type: Types.CI_DELETE,
    payload: payload,
});

export const deleteCISuccess = (payload) => ({
    type: Types.DELETE_CI_SUCCESS,
    payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

// planned maintenance

export const getPlannedList = (payload) => ({
    type: Types.GET_PLANNED_ITEMGROUPLIST,
    payload: payload,
});

export const setPlannedList = (payload) => ({
    type: Types.SET_PLANNED_ITEMGROUPLIST,
    payload: payload,
});

export const getPlannedCheckItemsByGroup = (payload) => ({
    type: Types.GET_PLANNED_ITEMSBYGROUP,
    payload: payload,
});

export const setPlannedCheckItemsByGroup = (payload) => ({
    type: Types.SET_PLANNED_ITEMSBYGROUP,
    payload: payload,
});

export const updatePlannedCIG = (payload) => ({
    type: Types.PLANNED_CIG_UPDATE,
    payload: payload,
});

export const addPlannedCIG = (payload) => ({
    type: Types.PLANNED_CIG_CREATE,
    payload: payload,
});

export const deletePlannedCIG = (payload) => ({
    type: Types.PLANNED_CIG_DELETE,
    payload: payload,
});

export const deletePlannedCIGSuccess = (payload) => ({
    type: Types.DELETE_PLANNED_CIG_SUCCESS,
    payload,
});

export const getPlannedListOfItems = () => ({
    type: Types.GET_PLANNED_ITEMLIST,
});

export const setPlannedListOfItems = (payload) => ({
    type: Types.SET_PLANNED_ITEMLIST,
    payload: payload,
});

export const updatePlannedCI = (payload) => ({
    type: Types.PLANNED_CI_UPDATE,
    payload: payload,
});

export const addPlannedCI = (payload) => ({
    type: Types.PLANNED_CI_CREATE,
    payload: payload,
});

export const deletePlannedCI = (payload) => ({
    type: Types.PLANNED_CI_DELETE,
    payload: payload,
});

export const deletePlannedCISuccess = (payload) => ({
    type: Types.DELETE_PLANNED_CI_SUCCESS,
    payload,
});

export const getPlannedCheckItemFiles = (payload) => ({
    type: Types.GET_PLANNED_CHECK_ITEM_FILES,
    payload: payload,
});

export const setPlannedCheckItemFiles = (payload) => ({
    type: Types.SET_PLANNED_CHECK_ITEM_FILES,
    payload: payload,
});

export const addPlannedCheckItemFiles = (payload) => ({
    type: Types.POST_PLANNED_CHECK_ITEM_FILES,
    payload: payload,
});

export const deletePlannedCheckItemFiles = (payload) => ({
    type: Types.DELETE_PLANNED_CHECK_ITEM_FILES,
    payload: payload,
});

export const getAutonomousCheckItemFiles = (payload) => ({
    type: Types.GET_AUTONOMOUS_CHECK_ITEM_FILES,
    payload: payload,
});

export const setAutonomousCheckItemFiles = (payload) => ({
    type: Types.SET_AUTONOMOUS_CHECK_ITEM_FILES,
    payload: payload,
});

export const addAutonomousCheckItemFiles = (payload) => ({
    type: Types.POST_AUTONOMOUS_CHECK_ITEM_FILES,
    payload: payload,
});

export const deleteAutonomousCheckItemFiles = (payload) => ({
    type: Types.DELETE_AUTONOMOUS_CHECK_ITEM_FILES,
    payload: payload,
});